/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import * as actiontype from './actionTypes';
import axios from 'axios';
import _ from 'lodash';
import * as serviceEndPoint from '../../../../../SharedModules/services/service';
import { pgmDetail } from '../../MaintainRebate/store/actions';

export const planType = (value) => {
  return { type: actiontype.PLAN_TYPE, payload: value };
};

export const rebateProgram = (value) => {
  return { type: actiontype.REBATE_PGM, payload: value };
};

export const updateFirstload = () => {
  return { type: actiontype.FIRST_LOAD_REB, payload: true };
};

export const clearReduxSearchRbt = () => {
  return { type: actiontype.CLEAR_SEARCH_REDUX };
};

export const errorMsgs = (value) => {
  return { type: actiontype.ERROR_MSG, payload: value };
};

export const getPlanTypes = () => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.GET_COMMON_MANUFACUTRE_DROPDOWNS}`, {
      codeDomainList: ['PLAN_TYPE_CD'],
    })
    .then((response) => {
      dispatch({ type: actiontype.PLAN_TYPE_LIST, payload: response.data });
    })
    .catch((response) => {
      dispatch({ type: actiontype.PLAN_TYPE_LIST, payload: [] });
    });
};

export const getRebateProgram = (planType) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.GET_ALL_REBATE_PROGRAMS}`, { planType: planType })
    .then((response) => {
      let list = [];
      const dropdown = response.data;
      if (dropdown?.status === '001' && dropdown?.message === 'SUCESS') {
        if (!_.isEmpty(dropdown?.data)) {
          list = _.map(dropdown?.data, (val, ind) => {
            return {
              ...val,
              id: val.rebateProgramCd,
              name: val.rebateProgramCd + ' | ' + val.shortDescr,
            };
          });
        }
      }
      list.sort((key, val) =>
        key.name.toLowerCase().localeCompare(val.name.toLowerCase())
      );
      // return dispatch({
      //   type: actiontype.REBATE_PGM_LIST,
      //   payload: list,
      // });
      return list;
    })
    .catch((response) => {
      // return dispatch({
      //   type: actiontype.REBATE_PGM_LIST,
      //   payload: [],
      // });
      return [];
    });
};

export const getRebatePgmDetail = (values) => (dispatch) => {
  return axios
    .post(serviceEndPoint.VIEW_REBATE_PGM, values)
    .then((response) => {
      dispatch({ type: actiontype.PGM_DETAIL, payload: response.data });
      dispatch(pgmDetail(response.data?.data?.[0]));
    })
    .catch((response) => {
      dispatch({ type: actiontype.PGM_DETAIL, payload: {} });
      dispatch(pgmDetail({}));
    });
};
